<template>
  <div>
    <vTable :items="studentFeeIDs" 
    :headers="studentFeeIDsHeaders"
     :title="isManager ? 'Total: '+ total : 'Fees For Years'"
     :deleteBtn="false"
     @items-deleted="anounceItemDeleted" 
     :editable="isManager"
     @text-value-changed="getEditedTextObject"
      :table="'student_fee_ids'"
     ></vTable>
  </div>
</template>

<script>
import axios from "@/plugins/axios"
import vTable from '@/components/Legos/vTable.vue';

export default {
    props:['total','studentFeeIDs'],
    computed:{
        getAccessToken(){
            return this.$store.getters.getAccessToken
        },
        isManager(){
            return this.$store.getters.isManager
        }
    },
    components:{
        vTable
    },
    data: () => ({
        studentFeeIDsHeaders:[
      {
        text: 'Year',
        value: 'year',
        notEditable:true
      },
      {
        text: 'FID',
        value: 'fid',
        notEditable:true
      },
      {
        text: 'Total Fee',
        value: 'total',
        notEditable:true
      },
      {
        text: 'Deposit',
        value: 'deposit'
      },
      {
        text: 'Months',
        value: 'months'
      }
      ,{
        text: 'Monthly',
        value: 'monthly'
      },
      {
        text: 'Starting Month',
        value: 'starting_month'
      }
    ]
    }),
    methods:{
        anounceItemDeleted(){
            this.$emit('fee-ids-deleted')
        },
        getEditedTextObject(feeIDObject){
            this.$store.commit('setLoader',true)
            axios.postDataWithToken('/auth/update-fees-all-times-table',{
                feeIDObject
            },this.getAccessToken)
            .then(response => {
                
                if(response == 'success'){
                    this.$store.commit('setLoader',false)
                    this.$toast.success('Item Updated Successfully!',{duration:3000})
                }else{
                    this.$toast.error('Oops, Something Went Wrong!',{duration:3000})
                }
            })
            
        }
    }
}
</script>
